
import React, { useState } from 'react';

import { post, get } from '../../../helpers/api_helper';
import { POST_UPDATE_MY_SETTING, GET_MY_SETTING } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';

import { useTranslation } from 'react-i18next';
import useMounted from '../../../hooks/useMounted';

const UserSetting = () => {
    const { t } = useTranslation();
    const [form_inputs, setFormInputs] = useState([]);
    const [isLoader, setLoader] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);

    useMounted(() => {
        async function get_detaile() {
            await get_app_setting();
            setLoader(1);
        }
        get_detaile();
    }, [])

    const get_app_setting = async () => {
        var res_data = await get(GET_MY_SETTING);
        if (res_data.status) {
            setFormInputs(res_data.data.weekOff);
        } else {
            toast.error(res_data.message);
        }
    }

    const dayMap = [
        { label: 'Sunday', code: 'Su' },
        { label: 'Monday', code: 'Mo' },
        { label: 'Tuesday', code: 'Tu' },
        { label: 'Wednesday', code: 'We' },
        { label: 'Thursday', code: 'Th' },
        { label: 'Friday', code: 'Fr' },
        { label: 'Saturday', code: 'Sa' },
    ];

    const handleInputChange = (e, code) => {
        const checked = e.target.checked;
        setFormInputs(prev =>
            checked ? [...prev, code] : prev.filter(day => day !== code)
        );
    };

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();

        SetButtonDisabled(true);
        var res_data = await post(POST_UPDATE_MY_SETTING, { weekOff: form_inputs });
        if (res_data.status) {
            await get_app_setting();
            toast(res_data.message);
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }


    return (
        <>
            {!isLoader && <Loader />}
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">{t('setting.title')}</h5>
                        <div className="card-body">
                            <div className='row ms-0'>
                                <div className='col-12'>
                                    <h6>{t('setting.selectWeekOff')}</h6>
                                    <div className='ms-3'>
                                        <form className="av-invalid row" onSubmit={handleSubmit}>
                                            {dayMap.map((day) => (
                                                <div className="form-check form-switch mb-2" key={day.code}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`switch-${day.code}`}
                                                        name="day_enable"
                                                        checked={form_inputs.includes(day.code)}
                                                        onChange={(e) => handleInputChange(e, day.code)}
                                                    />
                                                    <label className="form-check-label ms-2" htmlFor={`switch-${day.code}`}>
                                                        {day.label}
                                                    </label>
                                                </div>
                                            ))}

                                            <div className='text-center col-sm-12 mt-4'>
                                                <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                                    {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('update')}
                                                </button>
                                            </div>
                                        </form>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserSetting;